import { customerTypesI, customerTypesListI } from "interfaces"
import { get, remove, patch, post } from "services/services.methods"
import { CustomerTypesPaths } from "services/services.paths"

export const getCustomerTypes = async () => {
    const response = await get<customerTypesListI[]>(CustomerTypesPaths.get);

    return response.data;
};

export const removeCustomerType = async (id: number) => {
    const response = await remove<any>(CustomerTypesPaths.delete + `/${id}`);

    return response;
};

export const createCustomerTypes = async (customer: customerTypesI) => {
    const response = await post<any>(CustomerTypesPaths.post, customer);

    return response;
}

export const updateCustomerType = async (CustomerId: number, Customer: customerTypesI) => {
  const response = await patch<any>(CustomerTypesPaths.put + `/${CustomerId}`, Customer);

  return response;
};